import { Stack } from '@mui/system';
import { Divider, Typography, useTheme } from '@mui/material';
import { AreaLoader } from '../../UI';
import Generation from '../Generation';

interface IGenerateTabProps {
  isLoading: boolean;
  placeholder: string;
  loaderText: string;
  generations: string[];
}

const GenerateTab: React.FC<IGenerateTabProps> = ({ generations, isLoading, placeholder, loaderText }) => {
  const theme = useTheme();
  const isPlaceholder = !isLoading && placeholder && generations.length === 0;
  return (
    <>
      {isPlaceholder && (
        <Stack sx={{ alignSelf: 'center', flex: 1, justifyContent: 'center' }}>
          <Typography variant={'h3'} sx={{ color: theme.custom.palette.primary.lightgray }} align="center">
            {placeholder}
          </Typography>
        </Stack>
      )}
      {isLoading ? (
        <AreaLoader message={loaderText} small />
      ) : (
        <Stack
          divider={<Divider light />}
          sx={{
            maxHeight: 'calc(100vh - 260px)',
            overflowY: 'auto',
          }}
        >
          {generations.map((text, idx) => (
            <Generation key={idx} generation={text} />
          ))}
        </Stack>
      )}
    </>
  );
};

export default GenerateTab;
